import axios from "axios";
import {useQueryWithAuthentication} from "../../index";
import {addAuthToFetchOpts} from "../../../config/queryopts";
import {apiUrl} from "../../../config/api";


export const boardBlockListDomainFetcher = (accessToken, boardId) => {
  return axios.get(`${apiUrl}/operations/boards/${boardId}/blocked-lists/policy/dns`, addAuthToFetchOpts(accessToken, {})).then(res => res.data);
}

export const useBoardBlockListDomainQuery = (boardId, fetcher = boardBlockListDomainFetcher) => {
  return useQueryWithAuthentication(['board-blocklist-domain', boardId], (accessToken) => fetcher(accessToken, boardId), {
    staleTile: 0, cacheTime: 0
  })
}
